import React, { Component, Fragment } from "react";
import { Button } from "@mui/material";
import { Icon } from "__ICON_REFERENCE__";
import { withLocalizer } from "utilities/withLocalizer";
import commonUtilities from "utilities/common";
import RichTextEditor from "react-rte";
import moment from "moment";
import { connect } from "react-redux";
import { CONSTANTS } from "utilities/constants";
import LoadingSpinner from "components/common/loadingSpinner/loadingSpinner";

import getGroupContractEmail from "services/groupContractEmail/groupContractEmail.service";
import "./groupContract.scss";

class GroupContract extends Component {
    constructor(props) {
        super(props);
        this.state = {
            termsAndConditions: [],
            termsAndConditionString: "",
            isEmailSend: false,
            isCancelEmail: false,
            isContractLoading: false,
            language: this.props.language ?? commonUtilities.getLanguage()
        };
    }

    localize = (code) => {
        return this.props.localizeByLang(code, this.state.language);
    };

    onSaveTerms(id) {
        let { termsAndConditions } = this.state;

        let updatedTermsAndCondition = termsAndConditions[id];
        termsAndConditions?.map((term) => {
            if (term.id == id) { 
                term["description"] = updatedTermsAndCondition?.descriptionForEdit.toString("html");
                term.isEditTerms = false;
            }
        });

        this.setState({
            termsAndConditions
        });    
    }

    handleTerms = (id) => {
        let { termsAndConditions } = this.state;
        termsAndConditions[id].isEditTerms = !termsAndConditions[id].isEditTerms;
        this.setState({
            termsAndConditions
        });    
    };

    onChangeTerms = (value, index) => {

        let { termsAndConditions } = this.state;
    
        let updatedTermsAndCondition = termsAndConditions[index];
        if(updatedTermsAndCondition) {
            termsAndConditions[index] = { ...updatedTermsAndCondition, descriptionForEdit: value };
            this.setState({ termsAndConditions });   
        }
    };

    handleCancelTerms = (id) => {
        let { termsAndConditions } = this.state;
        let term = termsAndConditions[id];
        //console.log(term);
        term.isEditTerms = false;
        term.descriptionForEdit = RichTextEditor.createValueFromString(term.description, "html");

        this.setState({
            termsAndConditions
        });
    };

    sendEmail() {
        let { isEmailSend, termsAndConditionString, termsAndConditions } = this.state;
        isEmailSend = true;
        this.setState({ isEmailSend });

        setTimeout(() => {
            isEmailSend = false;
            this.setState({ isEmailSend });
           
        }, 5000);

        let payload = 
        {
            id: this.props?.groupContract?.id, 
            contractDescription: termsAndConditionString,
            termsAndConditions: termsAndConditions, 
            type: 2
        };

        this.props
            .dispatch(getGroupContractEmail(payload))
            .then((response) => {
                window.open("about:blank", "_self");
                window.close();
            });
    }

    cancelContract() {
        let { isCancelEmail } = this.state;

        isCancelEmail = true;
        this.setState({ isCancelEmail });

        setTimeout(() => {
            isCancelEmail = false;
            this.setState({ isCancelEmail });
            window.open("about:blank", "_self");
            window.close();
        }, 3000);



    }

    closeEmailPopup = () => {
        let { isEmailSend } = this.state;
        isEmailSend = false;
        this.setState({ isEmailSend });
    };


    render() {
        let { groupContract, groupContracts, groupTypes } = this.props || {};
        let groupInvoiceData = groupContract?.groupInvoiceSection?.toString()?.replace(/&nbsp;/g, " ");
        let groupTermsCondition = this.props?.groupContract?.groupTermsConditions;
        const { isEmailSend, isCancelEmail, isContractLoading } = this.state;

        const brand = process.env.REACT_APP_BRAND;
        const forPDF = this.props.forPDF ?? false;

        if(!forPDF && this.state.termsAndConditions.length === 0 && groupContract?.termsAndConditions != undefined && groupContract?.quoteNumber !== undefined) {
            let newTermAndConditions = [];
            if(groupContract?.termsAndConditions?.forEach(element => {
                let newDescription = forPDF ? "" : RichTextEditor.createValueFromString(element.description, "html");
                newTermAndConditions.push({ ...element, isEditTerms: false, descriptionForEdit: newDescription });      
            }));
       
            if (newTermAndConditions.length > 0) {
                this.setState({
                    termsAndConditions:newTermAndConditions,
                    termsAndConditionString:groupTermsCondition
                });
            }
        }
        let { termsAndConditions } = forPDF ? groupContract : this.state;

        const toolbarConfig = {
            // Optionally specify the groups to display (displayed in the order listed).
            display: ["INLINE_STYLE_BUTTONS", "BLOCK_TYPE_BUTTONS", "LINK_BUTTONS", "BLOCK_TYPE_DROPDOWN"],
            INLINE_STYLE_BUTTONS: [
                { label: "Bold", style: "BOLD", className: "custom-css-class" },
                //   {label: 'Italic', style: 'ITALIC'},
                { label: "Underline", style: "UNDERLINE" }
            ],
            BLOCK_TYPE_DROPDOWN: [
                { label: "Normal", style: "unstyled" },
                { label: "Heading Large", style: "header-one" },
                { label: "Heading Medium", style: "header-two" },
                { label: "Heading Small", style: "header-three" }
            ],
            BLOCK_TYPE_BUTTONS: [
                { label: "UL", style: "unordered-list-item" },
                { label: "OL", style: "ordered-list-item" }
            ]
        };

        const selectedLang = this.state.language; // commonUtilities.getLanguage();

        const groupType = commonUtilities.getGroupTypeName(selectedLang, groupContract?.groupSalesRepresentative?.type, groupTypes);

        return (
            <Fragment>
                <div className="group-contract-container">
                    {!forPDF ? null :
                        (brand === "wvi" ?
                            <div className="app-header-container pdf-header-container">
                                <div className="app-header-wrapper">
                                    <div className="app-header-logo-background desktop">
                                        __PDF_LOGO__
                                    </div>
                                </div>
                            </div> :   
                            <div className="company-heading">
                                __PDF_LOGO__
                            </div>
                        ) 
                    }
                    <div className="group-contract-contents">

                        <div className="group-contract-header">
                            <h1 className="contract-heading">
                                {this.localize("qma-group-contract-header") + " - " + groupContract?.quoteNumber}
                            </h1>
                        </div>

                        <div className="quote-details-container">
                            <div className="group-contract-quote-number-header">
                                {this.localize("qma-quote-number")}  {groupContract?.quoteNumber}
                            </div>

                            <div className="group-contract-created-date-header">
                                {this.localize("qma-view-date") + ": " + moment(groupContract?.createdDate).format("MMM DD[,] YYYY hh:mm [ET]")}
                            </div>

                            <div className="group-contract-contact-info row">
                                <div className="col-left-25-percent">
                                    <div className="group-contract-row">
                                        <strong>{this.localize("qma-agreement-between")}:</strong>
                                    </div>
                                    <div className="group-contract-row">
                                        {commonUtilities.parseHtml(groupContract?.sunwingOfficeAddress?.replace(/\n/g, "<br />"))}    
                                    </div>
                                </div>
                                <div className="col-left-25-percent">
                                    <div className="group-contract-row">
                                        <strong>{this.localize("qma-and")}:</strong>
                                    </div>
                                    <div className="group-contract-row">
                                        {commonUtilities.parseHtml(groupContract?.agencyDetails?.name)}
                                    </div>
                                    <div className="group-contract-row">
                                        {commonUtilities.parseHtml(groupContract?.agencyDetails?.address)}
                                    </div>
                                    <div className="group-contract-row row">
                                        <div className="col-left">
                                            {this.localize("qma-agency-number")}:
                                        </div>
                                        <div className="col-left">
                                            {commonUtilities.parseHtml(groupContract?.agencyDetails?.agencyNumber)}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-left-50-percent">
                                    <div className="group-contract-row">
                                        <strong>{this.localize("qma-group-sales-only")}:</strong>
                                    </div>
                                    <div className="group-contract-row row">
                                        <div className="col-left">
                                            {this.localize("qma-name")}:
                                        </div>
                                        <div className="col-left break-word">
                                            {groupContract?.groupSalesRepresentative?.name}
                                        </div>
                                    </div>
                                    <div className="group-contract-row row">
                                        <div className="col-left">
                                            {this.localize("qma-email")}:
                                        </div>
                                        <div className="col-left break-word">
                                            {groupContract?.groupSalesRepresentative?.email}
                                        </div>
                                    </div>
                                    <div className="group-contract-row row">
                                        <div className="col-left">
                                            {this.localize("qma-booking")} #:
                                        </div>
                                        <div className="col-left break-word">
                                            {groupContract?.groupSalesRepresentative?.bookingNumber}
                                        </div>
                                    </div>
                                    <div className="group-contract-row row">
                                        <div className="col-left">
                                            {this.localize("qma-group-name-type")}:
                                        </div>
                                        <div className="col-left break-word">
                                            {groupContract?.groupSalesRepresentative?.groupName + " / " }{ groupType }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="group-contract-row group-contract-terms-and-conditions row">
                                <div>
                                    {commonUtilities.parseHtml(groupContract?.headerTermsConditions)}
                                </div>
                                <div className="add-initials">
                                    [[i|1|id:0]]
                                </div>
                            </div>
                        </div>

                        <div className="html-row">
                            {commonUtilities.parseHtml(groupInvoiceData)}
                        </div>

                        <div className="contract-group-information-container">
                            <div className="group-contract-group-information-header">
                                {this.localize("qma-group-information-header")}
                            </div>

                            <div className="group-contract-row">
                                {commonUtilities.parseHtml(groupContract?.groupInformation?.replace(/\n/g, "<br />"))}
                            </div>
                        </div>


                        <div className="terms-and-conditions-container">
                            {
                                termsAndConditions.length > 0 && termsAndConditions?.map((term, index) => (
                                    !term.isEditTerms || forPDF ? (
                                        <>
                                            <div className="group-contract-group-terms-and-conditions-header" key={index}>
                                                <div>{term.title}</div>
                                                {forPDF ? null : 
                                                    <div className="print-hide">
                                                        <Button 
                                                            data-testid={"edit-btn"} 
                                                            variant="outlined" 
                                                            className="btn-white" 
                                                            onClick={() => this.handleTerms(index)}>
                                                            <Icon name="edit--n" className="margin-right" />
                                                            {this.localize("qma-edit")}
                                                        </Button>
                                                    </div>
                                                }
                                                
                                            </div>
                                            <div className="group-contract-row margin-top-2x">
                                                {commonUtilities.parseHtml(term.description)}
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <div className="group-contract-group-terms-and-conditions-header" key={index}>
                                                <div>{term.title}</div>
                                                <div className="print-hide">
                                                    <div className="row">
                                                        <Button
                                                            data-testid={"cancel-btn"}
                                                            variant="outlined"
                                                            className="btn-white margin-right-1x cancel-button"
                                                            onClick={() => this.handleCancelTerms(index)}
                                                        >
                                                            {this.localize("qma-cancel")}
                                                        </Button>
                                                        { }
                                                        <Button
                                                            data-testid={"save-btn"}
                                                            variant="outlined"
                                                            className="btn-white"
                                                            onClick={() => this.onSaveTerms(index)}
                                                        >
                                                            <Icon name={"checked--n"} className="margin-right" />
                                                            {this.localize("qma-save")}
                                                        </Button>
                                                    </div>
                                                </div>
                                            </div>

                                            <RichTextEditor
                                                className="richTextEditor"
                                                toolbarConfig={toolbarConfig}
                                                value={term.descriptionForEdit} 
                                                onChange={(value) =>
                                                    this.onChangeTerms(value, index)}
                                            />                                      
                                        </>
                                    )
                                ))
                            }
                        </div>
                        <div className="schedule-of-cancellation-container">
                            <div className="add-initials">
                                [[i|1|id:1]] 
                            </div>
                        </div>

                    </div>

                    <div className="group-contract-footer">

                        <div className="group-contract-footer-row border-top">
                            <div className="group-contract-row">
                                {this.localize("qma-contract-declaration-parties")}
                            </div>

                            <div className="group-contract-row margin-top-2x row">
                                <div className="col-left">
                                    <div className="group-contract-row">
                                        &nbsp;
                                    </div>
                                    <div className="signature-box">[[s|0]]</div>

                                    <div className="group-contract-row margin-top-10x">
                                        {groupContract?.groupSalesRepresentative?.name}
                                        <br />
                                        {this.localize("qma-group-sales-only")}
                                    </div>
                                </div>
                                <div className="col-left">
                                    <div className="group-contract-row">
                                        {"(Booking # " + groupContract?.groupSalesRepresentative?.bookingNumber + ")"}
                                    </div>
                                    <div className="signature-box">[[s|1]]</div>
                                    <div className="group-contract-row margin-top-10x">
                                        {groupContract?.agencyDetails?.name}
                                        <br />
                                        
                                    </div>
                                </div>
                            </div>
                            <div className="group-contract-row margin-top-6x row">
                                Date: <div className="date-box"> [[d|1]]</div>
                            </div>

                            <div className="group-contract-row signature-footer margin-top-1x">
                                <strong>{this.localize("qma-contract-retain-copy")}</strong>
                            </div>

                            <div className="group-contract-row footer-statement">
                                <p>{groupContract?.footer}</p>
                            </div>
                            {forPDF ? null :
                                <div className="group-contract-row margin-top-6x">
                                    <div className="group-contract-button">
                                        <Button
                                            data-testid={"cancel-email-contract"}
                                            variant="outlined"
                                            className="btn-red margin-right-1x"
                                            onClick={() => this.cancelContract()}>
                                            <Icon name={"close--n"} className="margin-right" />
                                            Cancel Contract
                                        </Button>

                                        <Button
                                            data-testid={"save-email-group-contract"}
                                            variant="outlined"
                                            className="btn-blue"
                                            onClick={() => this.sendEmail()}
                                        >
                                            <Icon name={"email"} className="margin-right" />
                                            Email Group Contract e-Signature Request
                                        </Button>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>

                {isEmailSend && !forPDF ? <div>
                    <div className="popup-container-bg delete-modal"></div>

                    <div className="popup-container">

                        <div className="popup-body">
                            <div className="close-popup-button" onClick={() => this.closeEmailPopup()}>
                                <Icon name="close--n" className="font-icon" />
                            </div>

                            <div className="popup-heading margin-bottom-1x email-popup-container">
                                       
                                <div className="email-logo-cover"></div>
                                <div className="email-declaration-text">
                                    {this.localize("qma-email-request")} 
                                </div>
                            </div>
                        </div>

                    </div>

                </div> : ""}

                {isCancelEmail && !forPDF  ? <div>
                    <div className="popup-container-bg delete-modal"></div>

                    <div className="popup-container">

                        <div className="popup-body">

                            <div className="popup-heading margin-bottom-1x">
                                No Group Contract has been generated.
                            </div>
                        </div>
                    </div>
                </div> : ""}
                
                {(isContractLoading || !groupContracts?.status)  && !forPDF ?  <LoadingSpinner /> : null}
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    groupContracts: state.groupContract
});

export default connect(mapStateToProps)(withLocalizer(GroupContract));